/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     入口脚本 main.js
  +--------------------------------------------------------------------------------------
*/

import Vue from "vue";
import router from "./router/router";
import store from "./store/store";
import App from "./App.vue";

// Element UI
import Element from "element-ui";
import "./iconfont/iconfont.css";
import "./styles/index.scss";
import "animate.css";
import "./iconfont/iconfont.js";
Vue.use(Element);

// 按需引入vxe-table
import XEUtils from "xe-utils";
import {
  VXETable,
  Header,
  Validator,
  Icon,
  Column,
  Table,
  Edit,
  Pulldown
} from "vxe-table";
/** 兼容element 时间选择器之类的无法选中 */
import VXETablePluginElement from "vxe-table-plugin-element";
import "vxe-table-plugin-element/dist/style.css";

/** 兼容element 时间选择器之类的无法选中 */
import zhCN from "vxe-table/lib/locale/lang/zh-CN";
VXETable.setup({
  i18n: (key, args) => XEUtils.toFormatString(XEUtils.get(zhCN, key), args)
});
VXETable.use(VXETablePluginElement);
Vue.use(Header)
  .use(Validator)
  .use(Icon)
  .use(Column)
  .use(Edit)
  .use(Table)
  .use(Pulldown);

// vue-photo-preview
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
Vue.use(preview);

// 将自动注册所有组件为全局组件
import dataV from "@jiaminghi/data-view";
Vue.use(dataV);

// Icon
// import "./icons/index";

// vue-count-to
import CountTo from "vue-count-to";
Vue.component("CountTo", CountTo);

// e粒子特效（vue-particles插件）
import VueParticles from "vue-particles";
Vue.use(VueParticles);

// html生成图片
// import VueHtml2Canvas from "vue-html2canvas";
// import html2canvas from 'html2canvas';
// Vue.use(html2canvas);

// 全局自定义组件注册
import FPageHeader from "./components/FPageHeader";
import FDateRangePicker from "./components/FDateRangePicker";
import FSearchInput from "./components/FSearchInput";
import FRadioBtnGroup from "./components/FRadioBtnGroup";
import FPagination from "./components/FPagination";
import FTableFooter from "./components/FTableFooter";
import FUserAvatar from "./components/FUserAvatar";
import FUserName from "./components/FUserName";
import FUploadFile from "./components/FUploadFile";
import FImageCardUploader from "./components/FImageCardUploader";
import FImage from "./components/FImage";
import FSeal from "./components/FSeal";
import FImageCropper from "./components/FImageCropper";
import StackBar from "./components/StackBar";
import OverTooltip from "./components/overTooltip.vue";
import FDatePicker from "./components/FDatePicker";
Vue.component("FPageHeader", FPageHeader);
Vue.component("FDateRangePicker", FDateRangePicker);
Vue.component("FSearchInput", FSearchInput);
Vue.component("FRadioBtnGroup", FRadioBtnGroup);
Vue.component("FPagination", FPagination);
Vue.component("FTableFooter", FTableFooter);
Vue.component("FUserAvatar", FUserAvatar);
Vue.component("FUserName", FUserName);
Vue.component("FUploadFile", FUploadFile);
Vue.component("FImageCardUploader", FImageCardUploader);
Vue.component("FImage", FImage);
Vue.component("FSeal", FSeal);
Vue.component("FImageCropper", FImageCropper);
Vue.component("StackBar", StackBar);
Vue.component("OverTooltip", OverTooltip);
Vue.component("FDatePicker", FDatePicker);

import IconSvg from '@/components/IconSvg'

Vue.component('icon-svg', IconSvg)
// Echarts
import echarts from "echarts";
import teenager from "@/components/FCharts/theme/teenager";
echarts.registerTheme("teenager", teenager);
Vue.prototype.$echarts = echarts;

/** -----MesWorkeorderDetail组件注册，全局挂载---- */
import MesWorkorderDetail from "@/views/mes/components/MesWorkorderDetail";
let instance = null;
let init = () => {
  const WorkorderDetail = Vue.extend(MesWorkorderDetail);
  MesWorkorderDetail.install = (data => {
    instance = new WorkorderDetail({
      data
    }).$mount();

    document.body.appendChild(instance.$el);
  })();
};
let ins = opts => {
  if (!instance) {
    init(opts);
  }
  Vue.nextTick(() => {
    instance.open(opts);
  });
};

Vue.prototype.$detail = ins;

/** -----MesWorkeorderDetail组件注册，全局挂载---- */
import Msg from "@/views/common/components/Msg";
let msgs = null;
let initi = () => {
  const Msgs = Vue.extend(Msg);
  Msg.install = (data => {
    msgs = new Msgs({
      data
    }).$mount();

    document.body.appendChild(msgs.$el);
  })();
};
let msg = opts => {
  if (!msgs) {
    initi(opts);
  }
  Vue.nextTick(() => {
    msgs.open(opts);
  });
};

Vue.prototype.$msg = msg;
/** -------------------------------------- */

// taskDetail
import taskDetail from "@/views/pm/components/task";
Vue.use(taskDetail);

/** -----StationDetail组件注册，全局挂载---- */
import StationDetail from "@/views/pp/components/StationDetail";
let detail = null;
let initd = () => {
  const Stationdetail = Vue.extend(StationDetail);
  StationDetail.install = (data => {
    console.log("[ data ] >", data);
    detail = new Stationdetail({
      data
    }).$mount();

    document.body.appendChild(detail.$el);
  })();
};
let sdetail = opts => {
  console.log("[ opt ] >", opts);
  if (!detail) {
    initd(opts);
  }
  Vue.nextTick(() => {
    detail.open(opts);
    if (opts.handleChange) detail.$on("change", opts.handleChange);
  });
};

Vue.prototype.$sdetail = sdetail;
/** -------------------------------------- */

// IM挂载
import im from "./utils/im";
Vue.prototype.$im = im;

// Permission
import "./permission";

// Global Filter
import * as filters from "./filters/filter";
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// Utils
import * as storage from "./utils/storage";
Vue.prototype.$utils = {
  saveListQuery: storage.saveListQuery,
  initListQuery: storage.initListQuery
};

Vue.config.productionTip = false;
// Vue.config.devtools = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
